/*!
 * Jentil (c) 2017-present GrottoPress
 * License: https://opensource.org/licenses/MIT
 * Home: https://www.grottopress.com/jentil/
 */
var Base = (function () {
    function Base(_j) {
        this._j = _j;
    }
    return Base;
}());
export { Base };
